import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'likeCount'
})
export class LikeCountPipe implements PipeTransform {

    transform(likeCount: number): string {
        if (likeCount <= 999) {
            return likeCount?.toString();
        } else if (likeCount <= 999999) {
            // Convert to K format (1.0K, 1.2K, etc.)
            return (likeCount / 1000).toFixed(1) + 'K';
        } else {
            // Convert to M format (1.0M, 1.2M, etc.)
            return (likeCount / 1000000).toFixed(1) + 'M';
        }
    }

}